import type { Customer } from '../customers';

export interface GoogleCalendarEventPrefill {
  title?: string;
  location?: string;
  description?: string;
  initialDate?: Date | null;
  attendeeEmail?: string | null;
  attendeeName?: string | null;
}

interface OpportunityPrefillInput {
  id: number;
  title?: string | null;
  source?: string | null;
  value?: number;
  customer_name?: string | null;
  next_follow_up_at?: string | null;
  customers?: {
    first_name?: string;
    last_name?: string;
  } | null;
}

function resolveCustomerName(
  customer: Customer | null,
  opportunity: OpportunityPrefillInput,
): string {
  if (customer) {
    const name = `${customer.first_name || ''} ${customer.last_name || ''}`.trim();
    if (name) return name;
  }
  if (opportunity.customer_name?.trim()) return opportunity.customer_name.trim();
  if (opportunity.customers) {
    const name = `${opportunity.customers.first_name || ''} ${opportunity.customers.last_name || ''}`.trim();
    if (name) return name;
  }
  return '';
}

/** Pre-populate a Google Calendar event from CRM opportunity + customer. */
export function buildGoogleCalendarPrefillFromOpportunity(
  opportunity: OpportunityPrefillInput,
  customer: Customer | null,
): GoogleCalendarEventPrefill {
  const customerName = resolveCustomerName(customer, opportunity);
  const attendeeEmail = customer?.email?.trim().toLowerCase() || undefined;

  return {
    title: 'Event',
    location: customer?.address?.trim() || undefined,
    attendeeEmail: attendeeEmail || null,
    attendeeName: customerName || null,
  };
}
